module.exports = __webpack_public_path__ + "static/img/ecu1.a170b99c.png";